import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ClusterState {
  clusterDetails: any[] | null | undefined;
  addEditFormData: any | null;
  isEdit: boolean;
  showAddEditForm: boolean;
  clusterMasterTable: any[] | null | undefined;
  companyList: any[] | null | undefined;
}

const clusterSlice = createSlice({
  name: "cluster",
  initialState: {
    clusterDetails: null,
    addEditFormData: null,
    isEdit: false,
    showAddEditForm: false,
    clusterMasterTable: null,
    companyList:null
  } as ClusterState,
  reducers: {
    setCluster(state, action: PayloadAction<any[] | null | undefined>) {
      state.clusterDetails = action.payload;
    },
    setAddEditFormData(state, action: PayloadAction<any | null>) {
      state.addEditFormData = action.payload;
    },
    setIsEdit(state, action: PayloadAction<boolean>) {
      state.isEdit = action.payload;
    },
    setShowAddEditForm(state, action: PayloadAction<boolean>) {
      state.showAddEditForm = action.payload;
    },
    setclusterMasterTable(state, action: PayloadAction<any[] | null | undefined>) {
      state.clusterMasterTable = action.payload;
    },
    setCompanyList(state, action: PayloadAction<any[] | null | undefined>) {
      state.companyList = action.payload;
    }
  },
});

export const clusterActions = clusterSlice.actions;
export { clusterSlice };
